// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"e18fac80","97":"ab2c10b9","485":"6e0e50ee","619":"4d5ea09e","624":"9c9cc89b","936":"8f417c61"}[chunkId] + ".chunk.css";
};